/**
 * The tags used to represent certain recording's attributes
 */
export var RecordingTags;
(function (RecordingTags) {
    RecordingTags["Realtime"] = "Realtime";
    RecordingTags["FTRGold"] = "FTR Gold";
    RecordingTags["SpeechToText"] = "Speech-to-Text";
    RecordingTags["Video"] = "Video";
    RecordingTags["LogNotes"] = "Log Notes";
    RecordingTags["Shared"] = "Shared";
    RecordingTags["Ordered"] = "Ordered";
    RecordingTags["Archived"] = "Archived";
    RecordingTags["Sealed"] = "Sealed";
})(RecordingTags || (RecordingTags = {}));
